import styled from 'styled-components';
export const RadioContainer = styled('div') `
  display: flex;
  justify-content: space-around;
  label {
    margin-right: 1rem;
    margin-bottom: .5rem;
  }
`;
